import React, { useState } from "react";
// import "../App.css";
import ParallaxSection from '../components/ParallaxSection'
import LogoCarousel from "../components/LogoCarousel";
import HeartBanner from "../components/Health/HeartBanner";
import SubStory from "../components/Health/SubStory"
import bgImage from "../Assets/agrotech/phoneagriculture.png";
import SubStone from "../components/Health/SubStone";
import OutreachSection from "../components/Health/HealthcareCommunityOutreach";
import Img1 from "../Assets/agrotech/agrotech1.png";
import Img2 from "../Assets/agrotech/agrotech2.png";
import Img3 from "../Assets/agrotech/agrotech3.png";
import SubJoinSection from "../components/Health/SubJoinSection";
import Subservicesmediacarousel from "../components/Health/Subservicesmediacarousel";
import plantboy from "../Assets/agrotech/plantboy.png";
import modalfarms from "../Assets/agrotech/modalfarms.png";
import solicare from "../Assets/agrotech/solicare.png";
import farmtech from "../Assets/agrotech/farmtech.png";
import training from "../Assets/agrotech/training.png";
import StatisticsSection from "../components/StatisticsSection";
import statsBg from '../Assets/stats-bg.png';
import bgImage2 from '../Assets/agrotech/bgimage2.png'
import agriboy from '../Assets/agrotech/agriboy.png'
import agriboy2 from '../Assets/agrotech/agriboy2.png'
import SchoolCard from "../components/Foundation/SchoolCard";
import agroheart from "../Assets/health/Ellipse 164.png"
import { Helmet } from "react-helmet-async";
import seoMeta from "./seoMeta";
import BuildersBuildWithUs from "../components/Builders/BuildersBuildWithUs"
import AgrotechBanner from "../components/Agrotech/AgrotechBanner"
import ComingSoon from "../components/ComingSoon";


const Agrotech = () => {
  const meta = seoMeta["/Agrotech"];
const logos = [
  { src: require('../Assets/LOGO/client1.png'), alt: 'Nestle' },
  { src: require('../Assets/LOGO/client2.png'), alt: 'Godrej' },
  { src: require('../Assets/LOGO/client3.png'), alt: 'Bajaj' },
  { src: require('../Assets/LOGO/client4.png'), alt: 'Reliance' },
  { src: require('../Assets/LOGO/client5.png'), alt: 'Safexpress' },
  { src: require('../Assets/LOGO/client6.png'), alt: 'JWL' },
  { src: require('../Assets/LOGO/client7.png'), alt: 'GIRIAS' },
  { src: require('../Assets/LOGO/client8.png'), alt: 'Nestle' },
    { src: require('../Assets/LOGO/client9.png'), alt: 'Denso' },
      { src: require('../Assets/LOGO/client10.png'), alt: 'Britania' },
        { src: require('../Assets/LOGO/client11.png'), alt: 'fsc' },
          { src: require('../Assets/LOGO/client12.png'), alt: 'ITC' },
            { src: require('../Assets/LOGO/client13.png'), alt: 'scope' },
            { src: require('../Assets/LOGO/client14.png'), alt: 'Flipkart' },
          ];
const paragraphs = [
    `VCNR Agrotech was born from the VCNR Group’s belief in innovation led growth, a growth that is designed to grow with purpose, compassion, and lasting value Since becoming an independent agri-tech vertical in 2021, we have focused on farmer-first solutions that make a difference.`,
    `From soilCARE kits to farm intelligence tools, we deliver digital solutions in agriculture that strengthen communities and protect the environment. Because to us, every seed carries a purpose and every harvest, a future.`,
  ];
  const paragraphs2 = [
    `At VCNR Agrotech, we bring together age old farming wisdom and modern innovation to empower farmers across the country. Whether it is a drone-based farming in India or carbon-credit cultivation pilots, our solutions are tested on the ground and guided by those who work it.`,
    `In partnership with universities and agri-tech startups, we create practical tools like AI-powered crop advisors and solar irrigation systems. Our goal: to make sustainable agriculture not just possible, but profitable for every farmer, everywhere.`,
    `By driving AI in farming across India, we are helping cultivate a future where technology supports tradition and every harvest tells a story of resilience.`
  ];
const paragraphs1 = [
  `We measure our success with the success stories of our patients. Through words, videos, and shared memories, We honor the strength of those who have healed with us. Their stories inspire our teams to go further.`
];
  const healthcareCards = [
  { image: Img1 },
  {image: Img2 },
  { image: Img3 },
  { image: Img3 },
  {image: Img2 },
  {  image: Img1 },
  {image: Img1 },
  { image: Img2 },
  { image: Img3 }
];
const quickAccessCards = [
  {
    title: "Step Into Opportunity\nGet the Brochure",
    buttonText: "Download Recruitment Brochure",
    buttonLink: "#"
  },
  {
    title: "Turn Connections\ninto Commissions",
    buttonText: "Referral Program Info",
    buttonLink: "#",
  },
  {
    title: "Connecting Talent\nwith Opportunity",
    buttonText: "Contact VCNR HR Team",
    buttonLink: "#"
  },
  {
    title: "Stay Ahead. Get Hired.\nOn WhatsApp",
    buttonText: "Join Our WhatsApp Hiring Channel",
    buttonLink: "#"
  }
];

const aboutTestimonials = [
  {
    stars: 5,
    title: "Amazing Experience!",
    text: "The whole journey was seamless and smooth. Would recommend to everyone!",
    author: "Ravi Kumar",
    location: "India, Bangalore",
    img: "https://i.pravatar.cc/40?img=9",
  },
  {
    stars: 4,
    title: "Truly Professional",
    text: "The team was very helpful and knowledgeable. They guided us at every step and made sure we got the best outcome.",
    author: "Neha Patel",
    location: "India, Mumbai",
    img: "https://i.pravatar.cc/40?img=10",
  },
  {
    stars: 5,
    title: "Exceeded Expectations",
    text: "From the first call to the final delivery, everything was well-managed and executed beyond my expectations.",
    author: "Mohammed Irfan",
    location: "India, Hyderabad",
    img: "https://i.pravatar.cc/40?img=11",
  },
  {
    stars: 4,
    title: "Reliable Support",
    text: "Even after the service was completed, they stayed in touch and provided great support when needed.",
    author: "Divya Menon",
    location: "India, Kochi",
    img: "https://i.pravatar.cc/40?img=12",
  },
  {
    stars: 5,
    title: "Effortless Process",
    text: "The process was transparent and smooth. I didn’t feel stressed at all and was kept informed throughout.",
    author: "Ankit Sharma",
    location: "India, Delhi",
    img: "https://i.pravatar.cc/40?img=13",
  },
  {
    stars: 5,
    title: "Highly Recommended",
    text: "One of the best service providers I’ve come across. Their ethics, efficiency, and execution are remarkable.",
    author: "Kritika Jain",
    location: "India, Pune",
    img: "https://i.pravatar.cc/40?img=14",
  },
  {
    stars: 5,
    title: "Customer First Approach",
    text: "They truly put the customer first. Every need of ours was taken care of. Thank you for such a positive experience.",
    author: "Ramesh Babu",
    location: "India, Chennai",
    img: "https://i.pravatar.cc/40?img=15",
  },
  {
    stars: 4,
    title: "Smooth Collaboration",
    text: "We worked on a collaborative project and it went smoothly thanks to their clear communication and technical expertise.",
    author: "Sonal Kapoor",
    location: "India, Jaipur",
    img: "https://i.pravatar.cc/40?img=16",
  },
];

const servicesData = [
  {
    title: "Model Farms",
    description: "Live demonstration hubs that showcase sustainable techniques, high yield crops, and eco-friendly farm automation turning best practices into everyday practices.",
    image: modalfarms,
  },
  {
    title: "SoilCARE & Inputs",
    description: "Custom soil testing kits and organic amendments built for precision farming in India, helping farmers make informed, climate resilient decisions.",
    image: solicare,
  },
  {
    title: "FarmTech Solutions",
    description: "Integrated systems for crop monitoring, smart irrigation, and agri-data collection delivering impactful digital solutions in agriculture across diverse terrains.",
    image: farmtech,
  },
  {
    title: "Training & Workshops",
    description: "Hands on farmer education programs covering climate smart farming, market access, and digital literacy helping rural communities adapt and thrive.",
    image: training,
  },
  {
    title: "Model Farms",
    description: "Live demonstration hubs that showcase sustainable techniques, high yield crops, and eco-friendly farm automation turning best practices into everyday practices.",
    image: modalfarms,
  },
  {
    title: "SoilCARE & Inputs",
    description: "Custom soil testing kits and organic amendments built for precision farming in India, helping farmers make informed, climate resilient decisions.",
    image: solicare,
  },
  {
    title: "FarmTech Solutions",
    description: "Integrated systems for crop monitoring, smart irrigation, and agri-data collection delivering impactful digital solutions in agriculture across diverse terrains.",
    image: farmtech,
  },
  {
    title: "Training & Workshops",
    description: "Hands on farmer education programs covering climate smart farming, market access, and digital literacy helping rural communities adapt and thrive.",
    image: training,
  },
];

const stats = [
    { value: 100, suffix: '+', label: 'Model Farms Established' },
    { value: 10000, suffix: '+', label: 'Farmers Trained' },
    { value: 50, suffix: 'K+', label: ' Acres Under Impact Farming' },
    { value: 20, suffix: '%', label: 'Average Yield Increase' },
    { value: 5, suffix: '*', label: 'States Covered' },
    { value: 10, suffix: 'M+', label: 'Farmer Revenue Growth' },
  ];


  return (
    <>
    <Helmet>
        <title>{meta.title}</title>
        <meta name="description" content={meta.description} />
        <meta name="keywords" content={meta.keywords} />
      </Helmet>
      <ComingSoon />
    {/* <HeartBanner
      heading="Sowing Seeds. Growing Futures with Agriculture Automation in India"
      subtext="At VCNR Agrotech, we combine smart innovation with real world farming to uplift rural communities. Through our agri-tech solutions, model farms, and farmer first networks, we drive sustainable growth nurturing both the land and the livelihoods that depend on it."
      buttonText="Know More"
      onButtonClick={() => alert("Heart section CTA clicked!")}
      heartImageSrc={agroheart}
      peopleImageSrc={plantboy}
      pulseLineSrc={""}
    /> */}
    {/* <AgrotechBanner />
<ParallaxSection><SubStory
      title={<>Purpose in Every Seed <br />Digital Solutions in Agriculture for a Resilient Tomorrow</>}
      subtitle="Where the Journey Started"
      paragraphs={paragraphs}
    /></ParallaxSection>

    <ParallaxSection><SubStone
  imageSrc={bgImage}
  heading={<>Together, we cultivate not  <br /> just crops but communities <br /> and possibilities</>}
  buttonText="About Us"
  onButtonClick={() => window.location.href = "/about"}
/></ParallaxSection>

<ParallaxSection><Subservicesmediacarousel
      title="Driving Precision Farming and Digital Agriculture in India"
      services={servicesData}
    /></ParallaxSection>

    <ParallaxSection><OutreachSection
          title="Our Agrotech Portfolio"
          cardsData={healthcareCards}
          buttonText="Explore Our Portfolio"
          onButtonClick={() => window.alert("Volunteer form will open")}
        /></ParallaxSection>

<ParallaxSection><StatisticsSection
            stats={stats}
            heading={<>Our Mission in Numbers.</>}
            description="From Soil to Yield, Real Results with Agri Innovation in India"
            backgroundImage={statsBg}
          />
          </ParallaxSection>

          <ParallaxSection><SubStory
      title="Cultivating the Future of Farming in India"
      subtitle="Where the Journey Started"
      paragraphs={paragraphs2}
    /></ParallaxSection>

    <ParallaxSection><SubStone
  imageSrc={bgImage2}
  heading={<>Innovation blossoms   <br /> when farmers and technologists <br /> grow together.</>}
  buttonText="About Us"
  onButtonClick={() => window.location.href = "/about"}
/></ParallaxSection>

<ParallaxSection><SchoolCard
  schoolName="Partnering for Smarter, "
  tagline="Sustainable Agriculture in India"
  features={[
    "NGO & Government Collaborations – Co-create climate resilient ecosystems, community farms, and digital agri-extension programs that bring agriculture automation in India to the grassroots.",
   "Corporate CSR Partnerships – Support sustainable farming pilots, precision farming initiatives, model farms, and rural training programs that uplift both people and the planet",
    "Agri-Tech Co-Innovation – Join us in developing the next wave of digital solutions in agriculture from AI-based crop advisors to eco-farming tools powered by real world data from our on ground network",
  ]}
  buttonText="Visit our Page"
  buttonLink="/school"
  schoolBgImage={agriboy}
/></ParallaxSection>


<ParallaxSection><BuildersBuildWithUs /></ParallaxSection>

<ParallaxSection><SubJoinSection

  image={agriboy2}
  title="VCNR Agrotech"
  subtitle="Join Forces with Us"
  
  description="Rooted in VCNR Group’s mission since 2007 to deliver innovation-led exponential growth, we are transforming agriculture through technology, training, and community empowerment"
  secondaryText="From our registered base in Nelamangala, Bengaluru Rural, to our expanding agri-ecosystem, we’re cultivating a future where every farmer thrives, every field flourishes, and every harvest builds lasting prosperity."
  buttonText = "Explore Careers"
  secondButtonText = "Explore More"
/></ParallaxSection>
 
          <ParallaxSection><LogoCarousel logos={[...logos, ...logos]} /></ParallaxSection> */}

    </>
  );
};

export default Agrotech;
